import "./heroSection.scss";
import React from "react";
import Button from "../../../../components/button/Button";
import {useHistory} from "react-router-dom";

const HeroSection = () => {
    const history = useHistory()
    return (
        <div className="hero__section">
            <div className="hero__section__wrapper">
                <h1 className="hero__section__wrapper__heading primary__heading">
                    24/7 Live Call Answering Service
                </h1>
                <p className="hero__section__wrapper__paragraph">
                    Quality Communication Services, Affordable Pricing With No Compromise!
                </p>
                <Button onclick={() => history.push('/pricing/answering-services')} type="secondary"
                        text="Get Started"/>
            </div>
        </div>
    );
};

export default HeroSection;
